export interface MinionDefinition {
  id: string;
  name: string;
  startingHp: number;
  attack: number;
  /** The minion's type classification (e.g., "warrior", "mage"). Exactly one type per minion. */
  minionType: string;
  baseAbilities: string[]; // Array of ability IDs
  allowedUpgradePaths: string[]; // List of upgrade path IDs
}

export class MinionDefinitionValidator {
  /**
   * Validates a minion definition and returns a valid MinionDefinition object.
   * @param definition The partial minion definition to validate.
   * @throws Error if any required field is missing or invalid.
   */
  static validate(definition: Partial<MinionDefinition>): MinionDefinition {
    if (!definition.id) throw new Error("Minion definition missing ID");
    if (!definition.name) throw new Error("Minion definition missing name");
    if (typeof definition.startingHp !== 'number') throw new Error("Minion definition missing startingHp");
    if (typeof definition.attack !== 'number') throw new Error("Minion definition missing attack");
    if (!definition.minionType || typeof definition.minionType !== 'string') throw new Error("Minion definition missing minionType");
    if (!Array.isArray(definition.baseAbilities)) throw new Error("Minion definition missing baseAbilities");
    if (!Array.isArray(definition.allowedUpgradePaths)) throw new Error("Minion definition missing allowedUpgradePaths");

    return {
      id: definition.id,
      name: definition.name,
      startingHp: definition.startingHp,
      attack: definition.attack,
      minionType: definition.minionType,
      baseAbilities: definition.baseAbilities,
      allowedUpgradePaths: definition.allowedUpgradePaths
    };
  }
}
